import { createWorldApi } from '../../shared/coloring/world/api';

import type { Tree3dWork, Tree3dWorld } from './types';

export const OWNER_TOKEN_KEY = 'gameinvitation:new-year-tree-3d-token';

/** Один экземпляр на модуль: хуки используют ссылку как зависимость. */
export const tree3dApi = createWorldApi<Tree3dWorld, Tree3dWork>({
  slug: 'new-year-tree-3d',
  itemsPath: 'works',
  idParam: 'workId',
  ownerTokenKey: OWNER_TOKEN_KEY,
  fallbackMessage: '«Новогодняя ёлка 3D» временно недоступна.',
});
